export default {
  notification: {
    success: {
      copy: 'Content copied successfully.',
    },
    error: {
      copy: 'Content could not be copied.',
    },
  },
  label: {
    tooltip: {
      copy: 'Click to copy the content.',
    },
    button: 'Copy',
  },
};
